import React, { Component } from "react";
import { ToastContainer } from "react-toastify";
import toast from "../helpers/toast";
import Httpconfig from "../helpers/HttpconfigDiagnostics";
import Constant from "../../constants";
import { MDBDataTable, MDBBadge, MDBContainer } from "mdbreact";
import DiagnosisHeader from "./DiagnosisHeader";
import DiagnosisMenu from "./DiagnosisMenu";
import { Link } from "react-router-dom";
import * as SecureLS from "secure-ls";
var ls = new SecureLS({
  encodingType: "aes",
  encryptionSecret: "medleymed",
});

export default class ViewDiagnosticscoupons extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page_data: "",
      datatable: {
        columns: [
          {
            label: "Coupon Name ",
            field: "coupon_name",
            sort: "asc",
            width: 150,
          },
          {
            label: "Start Date",
            field: "start_date",
            sort: "asc",
            width: 150,
          },
          {
            label: "End Date",
            field: "end_date",
            sort: "asc",
            width: 150,
          },
          {
            label: "Discount Type",
            field: "is_percentage",
            sort: "asc",
            width: 150,
          },
          {
            label: "Discount % / Flat",
            field: "discount",
            sort: "asc",
            width: 150,
          },
          {
            label: "Minimum Value",
            field: "minimumorder_value",
            sort: "asc",
            width: 150,
          },
          {
            label: "Maximum Discount Amount",
            field: "maximumdiscount_amount",
            sort: "asc",
            width: 150,
          },
          {
            label: "No Of Users",
            field: "numberof_user",
            sort: "asc",
            width: 150,
          },
          {
            label: "No Of Times",
            field: "numberof_times",
            sort: "asc",
            width: 150,
          },
          {
            label: "Actions",
            field: "actions",
            sort: "asc",
            width: 250,
          },
          {
            label: "Status",
            field: "status",
            sort: "asc",
            width: 250,
          },
        ],
        rows: [],
      },
    };
    this.deleteCoupon = this.deleteCoupon.bind(this);
  }

  // To get detais after first render
  componentDidMount = () => {
    let userData = ls.get("diagnosticsuserObj");
    if (userData) {
      if (userData != "") {
        this.setState({
          diagnosisId: userData.diagnosis_id,
        });
        this.forceUpdate();
      }
    } else {
      window.location.href = "/diagnostics/login";
    }
    this.fetchpagesdata(userData.diagnosis_id);
  };

  // When value changes of the fields
  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  //update status for patient

  updateStatus(id, status) {
    Httpconfig.httptokenput(
      Constant.siteurl + "api/Coupon/ActiveInactive/" + status + "/" + id
    )

      .then((response) => {
        toast.success("Successfully updates Status");

        setTimeout(() => window.location.reload(false), 2000);
      })

      .catch((error) => { });
  }
  // For getting the data
  fetchpagesdata(id) {
    Httpconfig.httptokenpost(Constant.siteurl + "api/Coupon/couponslist/", {
      retailer_id: id,
      module: "diagnostics",
    })
      .then((response) => {
        this.setState({
          page_data: response.data.data,
         
        });
        let assignvalues = [];

        this.items = response.data.data.map((item, key) => {
          assignvalues.push({
            coupon_name: item.coupon_name || '--',
            start_date: item.start_date || '--',
            end_date: item.end_date || '--',
            is_percentage: item.is_percentage || '--',
            discount: item.discount || '--',
            minimumorder_value: item.minimumorder_value || '--',
            maximumdiscount_amount: item.maximumdiscount_amount || '--',
            numberof_user: item.numberof_user || '--',
            numberof_times: item.numberof_times || '--',
            id: item.id,
            status: item.status,

            status:
              item.status == 1 ? (
                <MDBBadge
                  color="success"
                  onClick={() => this.updateStatus(item.id, false)}
                >
                  <a>
                    <h5>Active</h5>
                  </a>
                </MDBBadge>
              ) : (
                <MDBBadge
                  className="badge"
                  color="warning"
                  onClick={() => this.updateStatus(item.id, true)}
                >
                  <a>
                    <h5>In Active</h5>
                  </a>
                </MDBBadge>
              ),

            actions: (
              <div>
                <span>
                  <Link
                    to={"/diagnostics/Diagnosticscoupons/" + item.id}
                    className="fa fa-edit point-cursor"
                    title={"Update " + item.coupon_name}
                  ></Link>
                </span>{" "}
                &nbsp;
                <span>
                  <i
                    onClick={() => this.deleteCoupon(item.id, item.coupon_name)}
                    className="fa fa-trash point-cursor"
                    title={"Delete " + item.coupon_name}
                  ></i>
                </span>{" "}
                &nbsp;
              </div>
            ),
          });
        });

        let couponState = Object.assign({}, this.state);
        couponState.datatable.rows = assignvalues;
        this.setState(couponState);
      })
      .catch((error) => { });
  }

  //delete controller
  deleteCoupon(cpnId, name) {
    var isConfirm = window.confirm("Are you sure to delete " + name + "?");
    if (isConfirm) {
      Httpconfig.httptokendelete(Constant.siteurl + "api/coupon/"+cpnId )
      .then((response) => {
          toast.success("Successfully Deleted coupon");
          setTimeout(() => window.location.reload(), 2000);
        })
        .catch((error) => { });
    }
  }
  render() {
    const { datatable } = this.state;
    return (
      <main id="main">
        <DiagnosisHeader />
        <DiagnosisMenu />
        <section id="Pharmacy_dashboard">
          <div className="Pharma_Content">
            <div className="container-fluid">
              <div className="create-coupon-page">
                <div className="row ">
                  <div className="col-md-12">
                    <form>
                      <div className="tab-header create-coupon-header">
                        <h3> Coupons</h3>
                        <Link
                          to="/diagnostics/Diagnosticscoupons"
                          className="btn  btn-primary fright"
                        >
                          Create Coupons
                        </Link> 
                        </div>
                    </form>
                  </div>
                </div>
                <div className="row">
                  <div id="" className="viewcoupons">                          
                    {datatable.rows.length === 0 ? (
                      <p>No Coupons found</p>
                    ) : (
                      <MDBDataTable
                        responsive
                        striped
                        bordered
                        small
                        data={datatable}
                      />
                    )}

                    <div className="row">
                      <div className="col-md-12">
                        <div
                          className="update_btn"
                          style={{ textAlign: "right" }}
                        ></div>
                      </div>
                    </div>
                    <ToastContainer />
                  </div>
                </div>
              </div>
            </div>
          </div>                 
        </section>
      </main>
    );
  }
}
